'use strict';
var ua = window.navigator.userAgent;

/**
 * 判断设备是移动设备
 * @returns {boolean}
 */
function isMobileDevice() {
  return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i).test(ua);
}

/**
 * 判断是否是微信
 * @returns {boolean}
 */
function isWeChat() {
  return (/MicroMessenger/i).test(ua);
}



function isMobileQQBrowser() {
  return (/MQQBrowser/i).test(ua);
}

function isQQ() {
  return (/QQ/i).test(ua) && !isMobileQQBrowser();
}

function getDeviceRatio() {
  return window.devicePixelRatio || 1;
}

function isWebkit() {
  return (/WebKit/i).test(ua);
}

/**
 * is CriOS: ios chrome ua 中包含
 */
function isCriOS() {
  return (/CriOS/i).test(ua);
}

function isUC() {
  return (/UCBrowser/i).test(ua);
}

/**
 * 判断设备是否是 ios
 */
function isiOS() {
  return (/iPhone|iPad|iPod/i).test(ua) && window.navigator.standalone !== undefined; // may be use standalone is not a good habit
}

/**
 * 判断是否是 ios safari
 */
function isiOSSafari() {
  return (/(iPad|iPhone|iPod)/gi).test(ua) && !isCriOS() && !(/FxiOS/).test(ua) && !(/OPiOS/).test(ua) && !(/mercury/).test(ua) && !isUC() && !isQQ() && !isMobileQQBrowser();
}

function isStandalone() {
  return isiOSSafari() && window.navigator.standalone;
}

function isMac() {
  return ua.indexOf('Macintosh') !== -1;
}

var UX2017Pattern = /^https:\/\/run\.mockplus\.cn\/[a-z]{5}\//i;

function isUX2017Work() {
  return UX2017Pattern.test(window.location.href);
}

var isEn = window.lang === 'en' || window.en;
var isJp = window.lang === 'jp';
var isCn = (!isEn) && (!isJp);
var isEnOrJp = isEn || isJp;
var lang;
if (isEn) {
  lang = 'en';
} else if (isJp) {
  lang = 'jp';
} else {
  lang = 'cn';
}

function isIEOrEdge() {
  return ua.indexOf('MSIE ') > 0 || !!ua.match(/Trident.*rv\:11\./) || ua.indexOf('Edge') > -1;
}

// 判断是否为小程序
function isWxMiniApp() {
  return window.__wxjs_environment === 'miniprogram';
}

module.exports = {
  isMobileDevice: isMobileDevice,
  isWeChat: isWeChat,
  isQQ: isQQ,
  getDeviceRatio: getDeviceRatio,
  isiOS: isiOS,
  isStandalone: isStandalone,
  isMac: isMac,
  isUX2017Work: isUX2017Work,
  isIEOrEdge: isIEOrEdge,
  isWxMiniApp: isWxMiniApp,
  isJp: window.lang === 'jp',
  isEn: isEn,
  isEnOrJp: isEnOrJp,
  isCn: isCn,
  lang: lang
};



// WEBPACK FOOTER //
// ./src/helper/envHelper.js